<ion-card>
  <ion-card-header>
    <ion-toolbar>
      <ion-icon slot="start" size="large" [src]="'note' | getIcon"></ion-icon>
      <ion-title>Diario di anamnesi</ion-title>
    </ion-toolbar>
  </ion-card-header>

  <ion-card-content>
    <div class="ion-margin-start">
      <div
        class="c3-flex ion-justify-content-end ion-align-items-center ion-margin-start ion-margin-end"
      >
        <ion-buttons slot="end">
          <ion-spinner color="secondary" *ngIf="loading$ | async"></ion-spinner>

          <ion-button (click)="onAddNote()" color="secondary" fill="solid">
            <span>Aggiungi anamnesi</span>
            <ion-icon slot="end" [src]="'plus' | getIcon"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
    </div>
    <ion-card-header>
      <ion-toolbar>
        <ion-title>Storico di anamnesi del paziente</ion-title>
      </ion-toolbar>
      <ion-card-subtitle class="c3-flex ion-align-items-center"> </ion-card-subtitle>
    </ion-card-header>
    <ion-grid class="c3-flex-column c3-full-height">
      <ion-row class="c3-100-height">
        <ion-col size="12">
          <div class="c3-flex ion-align-items-center">
            <ion-icon
              size="small"
              color="tertiary"
              [src]="'information-outline' | getIcon"
              class="ion-margin-end"
            >
            </ion-icon>
            <span>
              <strong>Attenzione:</strong> è possibile modificare o eliminare una nota
              <strong>solo</strong> entro 5 giorni dalla data di inserimento.
            </span>
          </div>
        </ion-col>
        <ion-col class="app-table-container">
          <ion-progress-bar
            type="indeterminate"
            color="secondary"
            *ngIf="loading$ | async"
          ></ion-progress-bar>
          <ag-grid-angular
            class="c3-100-height c3-table-with-clickable-rows"
            c3DarkTable
            [modules]="agModules"
            [rowData]="historicalNotes$ | async"
            [columnDefs]="columnDefs"
            [gridOptions]="agGridOptions"
          >
          </ag-grid-angular>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>

<ng-template #actionsCellTmpl let-cell>
  <div class="c3-flex">
    <ion-buttons>
      <ion-button size="small" (click)="onEdit(cell.data)" c3Tooltip="Modifica nota">
        <ion-icon color="primary" [src]="'pencil' | getIcon"></ion-icon>
      </ion-button>
      <ion-button size="small" (click)="confirmDelete(cell.data)" c3Tooltip="Elimina nota">
        <ion-icon color="danger" [src]="'delete' | getIcon"></ion-icon>
      </ion-button>
    </ion-buttons>
  </div>
</ng-template>
